export default __webpack_public_path__ + "static/media/lightLogo.9ff21be9.gif";